import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { EventSeriesInstance } from "../utils";

export const useEventSeriesForCurrentBusiness = (
  refetch = false,
): {
  eventSeries: any[];
  actions: typeof EventSeriesInstance;
} => {
  const { seriesById } = useSelector((state: any) => state.eventSeries);
  const { activeBusiness } = useSelector((state: any) => state.business);

  useEffect(() => {
    if (activeBusiness && (refetch || !seriesById?.length)) {
      EventSeriesInstance.listForCurrentBusiness();
    }
  }, [activeBusiness, refetch]);

  const eventSeries: any[] = useMemo(
    () =>
      Object.values(seriesById as Record<number, any>).filter(
        (eventSeries: any) => eventSeries.businessId === activeBusiness?.id,
      ),
    [seriesById, activeBusiness],
  );

  return {
    eventSeries,
    actions: EventSeriesInstance,
  };
};
